import { render, staticRenderFns } from "./NewTableComponent.vue?vue&type=template&id=5d8f0c46&"
import script from "./NewTableComponent.vue?vue&type=script&lang=js&"
export * from "./NewTableComponent.vue?vue&type=script&lang=js&"
import style0 from "./NewTableComponent.vue?vue&type=style&index=0&id=5d8f0c46&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports